import {
  getAuthenticatedThemisClient,
  CurrencyConfigurationView,
} from '@modifi/onboarding-api-clients'
import {EntityFactory} from '@modifi/redux'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: 'data/currencies',
  reducerPath: ['data', 'currencies', 'entity'],
  fetchRequest: () => apiClient.StaticData.fetchCurrencies().then(res => res.data()),
})

export default reducer

const selectCurrencyConfig = (state: Record<string, any>): CurrencyConfigurationView =>
  selectors.selectEntity(state) || {}

const aFetchCurrencies = (): AppThunkAction => actions.fetch()

export const aEnsureFetchCurrencies =
  (): AppThunkAction<void> =>
  (dispatch, getState): void => {
    const currencyConfig = selectCurrencyConfig(getState())
    if (!currencyConfig?.financingCurrencies) {
      dispatch(aFetchCurrencies())
    }
  }
